export default __webpack_public_path__ + "static/ay-support-content-email-us-9f08831a328c664e70a56fb3dd735d70.svg";